import React from 'react';
import ReactGridLayout from 'react-grid-layout';
import styled from 'styled-components';
import { Box } from '@material-ui/core';
import { GridLayoutProps } from './types';

const StyledGridLayout: React.FunctionComponent<GridLayoutProps> = props => <ReactGridLayout {...props} />;

export const GridLayout = styled(StyledGridLayout)`
    background-size: ${props => props.backgroundSize}px;
    background-image: url(/cell.png);
    height: ${props => props.height}px;
    width: ${props => props.width}px;
    position: relative;
    margin: auto;
`;

export const GridLayoutWraper = styled(Box)`
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    flex-grow: 1;
`;
